module.exports = __webpack_public_path__ + "static/img/bg_2_2.7bb0038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_2.png
// module id = B+mh
// module chunks = 3